export const sort = (list: any) => {
    return list ? list.slice().sort((a: any, b: any) => a.sortOrder - b.sortOrder) : list;
};